import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import PendingTxnListPageUI from './PendingTxnListPageUI.js'

const getTodayISO = () => {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

const addDaysISO = (dateISO, days) => {
  const d = new Date(`${dateISO}T00:00:00`)
  d.setDate(d.getDate() + days)
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

const formatReportDate = (dateISO) => {
  if (!dateISO) return ''
  const d = new Date(`${dateISO}T00:00:00`)
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  return `${String(d.getDate()).padStart(2, '0')} ${months[d.getMonth()]}, ${d.getFullYear()}`
}

class PendingTxnListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: 'dailyPayments',
      errorList: null,
      declineSubmitted: false,
      approveSubmitted: false,
      deleteMode: false,
      transactionList: null,
      totalAmountF1: null,
      subtotalsByTypeBadge: null,
      filteredTransactionList: null,
      selectedTxnId: null,
      searchFilter: '',
      copyToClipboardText: null,
      eventList: null,
      showDetails: false,
      selectedReferenceId: null,
      downloadMode: false,
      downloadTotalMode: false,
      dailyPaymentsReport: null,
      reportDateISO: getTodayISO(),
      reportLoading: false,
      pendingTransactionsLoaded: false,
      dailyPaymentsDownloadMode: false,
      emailSending: false,
    }
  }

  render() {
    const isCurrentDayReport = this.state.reportDateISO === getTodayISO()
    return (
      <PendingTxnListPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        activeTab={this.state.activeTab}
        onTabChange={this.onTabChange}
        transactionList={this.state.transactionList}
        totalAmountF1={this.state.totalAmountF1}
        subtotalsByTypeBadge={this.state.subtotalsByTypeBadge}
        filteredTransactionList={this.state.filteredTransactionList}
        onRefreshClick={this.onRefreshClick}
        onDeclineClick={this.onDeclineClick}
        declineSubmitted={this.state.declineSubmitted}
        onApproveClick={this.onApproveClick}
        approveSubmitted={this.state.approveSubmitted}
        deleteMode={this.state.deleteMode}
        onDeleteClick={this.onDeleteClick}
        onCancelDelete={() => { this.setState({ deleteMode: false }) }}
        selectedTxnId={this.state.selectedTxnId}
        searchFilter={this.state.searchFilter}
        onSearchFilterChange={this.onSearchFilterChange}
        copyToClipboardText={this.state.copyToClipboardText}
        onCopyToClipboard={this.onCopyToClipboard}
        eventList={this.state.eventList}
        selectedReferenceId={this.state.selectedReferenceId}
        showDetails={this.state.showDetails}
        onShowDetails={this.onShowDetails}
        downloadMode={this.state.downloadMode}
        onDownloadClick={this.onDownloadClick}
        onDownloadTotalBadgeType={this.onDownloadTotalBadgeType}
        dailyPaymentsReport={this.state.dailyPaymentsReport}
        reportDateISO={this.state.reportDateISO}
        isCurrentDayReport={isCurrentDayReport}
        reportLoading={this.state.reportLoading}
        onPreviousReportClick={this.onPreviousReportClick}
        onNextReportClick={this.onNextReportClick}
        formatReportDate={formatReportDate}
        onDailyPaymentsDownloadClick={this.onDailyPaymentsDownloadClick}
        dailyPaymentsDownloadMode={this.state.dailyPaymentsDownloadMode}
        onSendDailyPaymentsEmailClick={this.onSendDailyPaymentsEmailClick}
        emailSending={this.state.emailSending}
      />
    )
  }

  componentDidMount() {
    this.getDailyPaymentsReport(this.props.context, this.state.reportDateISO)
  }

  onTabChange = (tab) => {
    if (tab === this.state.activeTab) return
    this.setState({ activeTab: tab, errorList: null })
    if (tab === 'pendingTransactions' && !this.state.pendingTransactionsLoaded) {
      this.getPendingTransactions(this.props.context)
    }
  }

  getDailyPaymentsReport(context, dateISO) {
    this.setState({ reportLoading: true, errorList: null, reportDateISO: dateISO })
    const cacheManager = new CacheManager({
      resource: `/api/su/daily_payment_report/${dateISO}`,
      cacheKey: CacheKeys.DailyPaymentsReport(dateISO),
      callback: this.getDailyPaymentsReportCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getDailyPaymentsReportCallback = (response) => {
    const errorList = response.errorList && response.errorList.length
      ? response.errorList.map(error => error.message)
      : null
    this.setState({
      dailyPaymentsReport: errorList ? null : response,
      reportDateISO: response.dateISO || this.state.reportDateISO,
      reportLoading: false,
      errorList: errorList,
    })
  }

  onPreviousReportClick = (event) => {
    if (event) event.preventDefault()
    const previousDateISO = addDaysISO(this.state.reportDateISO, -1)
    CacheManager.removeObject(CacheKeys.DailyPaymentsReport(this.state.reportDateISO))
    this.setState({ dailyPaymentsReport: null })
    this.getDailyPaymentsReport(this.props.context, previousDateISO)
  }

  onNextReportClick = (event) => {
    if (event) event.preventDefault()
    const nextDateISO = addDaysISO(this.state.reportDateISO, 1)
    if (nextDateISO > getTodayISO()) return
    CacheManager.removeObject(CacheKeys.DailyPaymentsReport(this.state.reportDateISO))
    this.setState({ dailyPaymentsReport: null })
    this.getDailyPaymentsReport(this.props.context, nextDateISO)
  }

  getPendingTransactions(context) {
    const cacheManager = new CacheManager({
      resource: `/api/su/transactions/pending`,
      cacheKey: CacheKeys.PendingTxns(),
      callback: this.getPendingTransactionsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getPendingTransactionsCallback = (response) => {
    const filtersStr = sessionStorage.getItem(CacheKeys.PendingTxnsFilter())
    const filters = filtersStr ? JSON.parse(filtersStr) : {}
    this.setState({
      totalAmountF1: response.totalAmountF1,
      subtotalsByTypeBadge: response.subtotalsByTypeBadge,
      pendingTransactionsLoaded: true,
    })
    this.applyFilters(response.transactionList, filters.searchFilter ? filters.searchFilter : '', response.errorList)
  }

  onCopyToClipboard = (text, result) => {
    this.setState({ copyToClipboardText: text })
    setTimeout(() => {
      this.setState({ copyToClipboardText: null })
    }, 3000)
  }

  onDeclineClick = (event) => {
    let declineSubmitted = this.state.declineSubmitted
    if (declineSubmitted)
      return

    let transactionId = event.target.getAttribute('data-row-id')

    this.setState({
      successMsg: null,
      errorList: [],
      declineSubmitted: true,
      selectedTxnId: transactionId
    })

    RestApiUtils.put(this.props.context,
      `/api/su/transactions/${transactionId}/decline`, this.onDeclineCallback, {}
    )
  }

  onDeclineCallback = (response) => {
    let errorList = []

    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
      })
    }

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      declineSubmitted: false
    })

    if (errorList.length === 0) {
      this.onRefreshClick()
    }
  }

  onApproveClick = (event) => {
    let approveSubmitted = this.state.approveSubmitted
    if (approveSubmitted)
      return

    let transactionId = event.target.getAttribute('data-row-id')

    this.setState({
      successMsg: null,
      errorList: [],
      approveSubmitted: true,
      selectedTxnId: transactionId
    })

    RestApiUtils.put(this.props.context,
      `/api/su/transactions/${transactionId}/approve`, this.onApproveCallback, {}
    )
  }

  onApproveCallback = (response) => {
    let errorList = []

    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
      })
    }

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      approveSubmitted: false
    })

    if (errorList.length === 0) {
      this.onRefreshClick()
    }
  }

  onDeleteClick = (event) => {
    let transactionId = event.target.getAttribute('data-row-id')
    this.setState({
      deleteMode: true,
      selectedTxnId: transactionId
    })
  }

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({ searchFilter: searchFilter })
    this.applyFilters(this.state.transactionList, searchFilter)
  }

  applyFilters(transactionList, searchFilter, errorList) {
    let filteredList = transactionList
    if (searchFilter)
      filteredList = filteredList.filter(txn => txn.accountName.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase()))

    this.setState({
      transactionList: transactionList,
      filteredTransactionList: filteredList,
      searchFilter: searchFilter,
      errorList: errorList
    })

    let filters = { searchFilter: searchFilter }
    sessionStorage.setItem(CacheKeys.PendingTxnsFilter(), JSON.stringify(filters))
  }

  onShowDetails = (event) => {
    let referenceId = event.target.getAttribute('data-row-id')
    let parts = referenceId.split('_')
    this.setState({
      successMsg: null,
      errorList: [],
      showDetails: true,
      selectedReferenceId: parts[0],
      selectedTxnId: parts[1],
      eventList: null
    })
    RestApiUtils.get(this.props.context,
      `/api/su/icici/ePayment/references/${parts[0]}/events`,
      this.onShowDetailsCallback, null, null
    )
  }

  onShowDetailsCallback = (response) => {
    let errorList = []

    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
      })
    }

    this.setState({
      eventList: response.eventList,
      successMsg: response.success,
      errorList: errorList,
      showDetails: false
    })
  }

  onDownloadClick = () => {
    this.setState({ downloadMode: true })

    RestApiUtils.get(this.props.context,
      `/api/su/transactions/pending/excel/fileDownloadSignedUrl`,
      this.onDownloadClickCallback, null, null
    )
  }

  onDownloadClickCallback = (response) => {
    this.setState({ downloadMode: false, errorList: response.errorList })
    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  onDownloadTotalBadgeType = () => {
    this.setState({ downloadTotalMode: true })

    RestApiUtils.get(this.props.context,
      `/api/su/transactions/typeBadgeTotal/excel/fileDownloadSignedUrl`,
      this.onDownloadTotalBadgeTypeCallback, null, null
    )
  }

  onDownloadTotalBadgeTypeCallback = (response) => {
    this.setState({ downloadTotalMode: false, errorList: response.errorList })
    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  onRefreshClick = () => {
    if (this.state.activeTab === 'dailyPayments') {
      CacheManager.removeObject(CacheKeys.DailyPaymentsReport(this.state.reportDateISO))
      this.setState({ dailyPaymentsReport: null, errorList: null })
      this.getDailyPaymentsReport(this.props.context, this.state.reportDateISO)
      return
    }
    CacheManager.removeObject(CacheKeys.PendingTxns())
    this.setState({ transactionList: null, errorList: null, eventList: null })
    this.getPendingTransactions(this.props.context)
  }

  onDailyPaymentsDownloadClick = () => {
    this.setState({ dailyPaymentsDownloadMode: true, errorList: null })

    RestApiUtils.get(this.props.context,
      `/api/su/daily_payment_report/${this.state.reportDateISO}/excel/fileDownloadSignedUrl`,
      this.onDailyPaymentsDownloadCallback, null, null
    )
  }

  onDailyPaymentsDownloadCallback = (response) => {
    const errorList = response.errorList || []
    this.setState({ dailyPaymentsDownloadMode: false, errorList: errorList.length ? errorList : null })
    if (errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  onSendDailyPaymentsEmailClick = () => {
    if (this.state.emailSending) return
    this.setState({ emailSending: true, errorList: null })

    RestApiUtils.post(
      this.props.context,
      `/api/su/daily_payment_report/sendEmail`,
      this.onSendDailyPaymentsEmailCallback,
      {}
    )
  }

  onSendDailyPaymentsEmailCallback = (response) => {
    const errorList = response && response.errorList ? response.errorList : []
    this.setState({
      emailSending: false,
      errorList: errorList.length ? errorList : null,
    })
  }
}

export default PendingTxnListPageSF
